import {
    Clock,
    TrendingUp,
    Users,
    ShieldCheck
} from 'lucide-react';

import { shopifyIntegration } from './integrations/shopify';
import { wordpressIntegration } from './integrations/wordpress';
import { wixIntegration } from './integrations/wix';
import { squarespaceIntegration } from './integrations/squarespace';
import { otherPlatforms } from './integrations/platforms';

export interface IntegrationStep {
    title: string;
    desc: string;
    image?: string;
    imgAlt?: string;
}

export interface IntegrationTab {
    id: string;
    label: string;
    content: {
        desc?: string;
        steps: IntegrationStep[];
        snippet?: string;
    };
}

export interface IntegrationBenefit {
    title: string;
    desc: string;
    icon: any;
    color: string;
    bg: string;
}

export interface IntegrationGuide {
    id: string;
    title: string;
    name: string;
    icon: any;
    why: string;
    desc?: string;
    steps?: IntegrationStep[];
    tabs?: IntegrationTab[];
    detailedGuide?: string;
    platformColor?: string;
}

export const INTEGRATION_BENEFITS: IntegrationBenefit[] = [
    {
        title: "Enhanced Support & Engagement",
        desc: "Chatbots provide instant, automated responses to customer inquiries, reducing wait times and improving satisfaction.",
        icon: Users,
        color: "text-primary",
        bg: "bg-primary/10"
    },
    {
        title: "24/7 Availability",
        desc: "Unlike human support teams, chatbots operate around the clock, ensuring customers receive assistance anytime—regardless of time zones.",
        icon: Clock,
        color: "text-emerald-500",
        bg: "bg-emerald-50 dark:bg-emerald-900/20"
    },
    {
        title: "Increased Sales & Conversions",
        desc: "Timely responses prevent lost sales. Chatbots guide users through the buying process and offer personalized recommendations.",
        icon: TrendingUp,
        color: "text-primary",
        bg: "bg-primary/10"
    },
    {
        title: "Reduced Support Costs",
        desc: "Automating repetitive queries reduces the workload on your support team, allowing them to focus on complex issues.",
        icon: ShieldCheck,
        color: "text-amber-500",
        bg: "bg-amber-50 dark:bg-amber-900/20"
    }
];

export const INTEGRATION_GUIDES: Record<string, IntegrationGuide> = {
    shopify: shopifyIntegration,
    wordpress: wordpressIntegration,
    wix: wixIntegration,
    squarespace: squarespaceIntegration,
    ...otherPlatforms
};
